export type VaultModuleName =
  | 'ingest'
  | 'preservation'
  | 'retention'
  | 'legal_hold'
  | 'reports';

export interface FolderPermission {
  id: string;
  module_permission_id?: string;
  project_id?: number | null;
  subfolder_path?: string | null;
  project_name?: string | null;
  created_at?: string;
}

export interface ModulePermission {
  id: string;
  user_id: string;
  tenant_id: string;
  module_name: VaultModuleName | string;
  is_enabled: boolean;
  created_at?: string;
  updated_at?: string | null;
  user_email?: string | null;
  user_full_name?: string | null;
  tenant_name?: string | null;
  folder_permissions: FolderPermission[];
}

export interface ModulePermissionCreatePayload {
  user_id: string;
  tenant_id: string;
  module_name: string;
  is_enabled?: boolean;
  folder_permissions?: Array<{
    project_id?: number | null;
    subfolder_path?: string | null;
  }>;
}

export interface ModulePermissionUpdatePayload {
  is_enabled?: boolean;
}

export interface FolderPermissionCreatePayload {
  project_id?: number | null;
  subfolder_path?: string | null;
}

export interface ModulePermissionListParams {
  user_id?: string;
  tenant_id?: string;
  module_name?: string;
}

export const VAULT_MODULE_OPTIONS: Array<{ label: string; value: VaultModuleName }> = [
  { label: 'Ingesta de Archivos', value: 'ingest' },
  { label: 'Preservación Digital', value: 'preservation' },
  { label: 'Retención Documental', value: 'retention' },
  { label: 'Legal Hold', value: 'legal_hold' },
  { label: 'Reportes Avanzados', value: 'reports' },
];
